import axios from 'axios'
import { Notify } from 'vant'
import router from '@/router'
axios.defaults.baseURL = '/api'
axios.defaults.withCredentials = true

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    config.headers['X-TuoBo-Media-Type'] = 'wy.manager.v1'
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['Authorization'] = getToken()
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const data = response.data
    if (response.status === 401 || data.code === 401) {
      Notify({ type: 'warning', message: '未授权，正在重定向到登录页面...' })
      router.push('/login').catch(() => {
        window.location.href = '/login'
      })
      // return Promise.reject(new Error('401'))
    } else if (response.status !== 200 || data.code !== 0) {
      Notify(data.message)
      return Promise.reject(new Error(data.message || 'Error'))
    } else {
      return data
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (error.response.data.code === 401) {
      location.reload()
    } else if (error.response.data.message) {
      console.log(error.response.data.message)
      Notify(error.response.data.message)
    } else {
      console.log(error.message)
      Notify(error.message)
    }
    return Promise.reject(error)
  }
)

export default service
